/**
 * Préférence de son, partagée entre tous les écrans (titre, HUD de combat).
 * Persistée dans `localStorage` (best-effort, jamais bloquant — mode privé,
 * quota dépassé, etc. redeviennent simplement « son activé » par défaut).
 */
const KEY = 'diceordie.muted';

function store(): Storage | null {
  try {
    if (typeof localStorage === 'undefined') return null;
    return localStorage;
  } catch {
    return null;
  }
}

export function isMuted(): boolean {
  try {
    return store()?.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function setMuted(muted: boolean): void {
  try {
    store()?.setItem(KEY, muted ? '1' : '0');
  } catch {
    /* ignore */
  }
}
